import React from 'react'
import PropTypes from 'prop-types'
import { Card } from '@resurs/midas-react'
import { getText } from '../../../../internal/TextLabels'
import { CustomerTypeModel } from '../../models/private-models'

const PaymentMethodDescription = ({ method }) => {
  let type = null
  if (method.customerType === CustomerTypeModel.NATURAL) {
    type = getText(`payApply.paymentMethod.descriptions.private.${method.type}`)
  } else if (method.customerType === CustomerTypeModel.LEGAL) {
    type = getText(`payApply.paymentMethod.descriptions.legal.${method.type}`)
  }
  const headerStyle = {
    fontWeight: 'bold',
    paddingBottom: '1rem',
    marginTop: '.5rem',
  }
  if (type && type.length > 0) {
    return (
      <Card>
        <ul style={{ margin: 0, listStyleType: 'none', fontSize: '1.2rem' }}>
          {type.map((t, index) => (
            <li
              key={t}
              style={index === 0 ? headerStyle : { marginTop: '.5rem' }}
            >
              {t}
            </li>
          ))}
        </ul>
      </Card>
    )
  }
  return <span>{type}</span>
}

PaymentMethodDescription.propTypes = {
  method: PropTypes.object.isRequired,
}

export default PaymentMethodDescription
